import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './common.scss';
import './PrepaidRecord.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import prepaidRecordSvg from '../../assets/prepaid-record.svg';
import noDataSvg from '../../assets/no-data.svg';
import axios from 'axios';
import { AuthValid } from 'shared/httpHandler';
import { encodeBase64Object } from 'shared/common';
import Loading from 'pages/toyotaOfficialAccount/Loading';

const tabs = [
  { key: 'all', label: '所有資料' },
  { key: 'gift', label: '定保機油禮包' },
  { key: 'coupon', label: '機油折抵券' },
];

const records = [
  { id: 1, store: '北都 中正服務廠', date: '2025/05/27', title: '定保機油禮包', value: '-$2,000', type: 'gift' },
  { id: 2, store: '北都 中正服務廠', date: '2025/04/16', title: '5年14萬公里板噴餘額', value: '-$2,000', type: 'gift' },
  { id: 3, store: '北都 中正服務廠', date: '2025/03/12', title: '定保機油禮包', value: '-$2,000', type: 'gift' },
  { id: 4, store: '北都 中正服務廠', date: '2025/03/08', title: '機油券(1L)', subtitle: '特邀活動(保修站)', value: '-1張', type: 'coupon' },
  { id: 5, store: '北都 中正服務廠', date: '2025/03/08', title: '機油券(1L)', subtitle: 'CPO交車大禮包', value: '-1張', type: 'coupon' },
  { id: 6, store: '北都 中正服務廠', date: '2025/03/08', title: '機油券(1L)', subtitle: '營業車特邀', value: '-1張', type: 'coupon' },
  { id: 7, store: '北都 中正服務廠', date: '2025/03/08', title: '機油券(1L)', subtitle: '定保機油禮包', value: '-1張', type: 'coupon' },
  { id: 8, store: '北都 中正服務廠', date: '2025/03/08', title: '定期保養優惠券', value: '-1張', type: 'coupon' },
  { id: 9, store: '北都 中正服務廠', date: '2024/12/31', title: '五年14萬公里延保', value: '已到期', type: 'expired' },
];

const PrepaidRecord = () => {
  const navigate = useNavigate();

  const [token, setToken] = useState('');
  const [carNo, setCarNo] = useState('');
  const [lineId, setLineId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [records, setRecords] = useState([]);

  const [activeTab, setActiveTab] = useState('all');
  const filtered = activeTab === 'all' ? records : records.filter(r => r.type === activeTab);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    try {
      const payload = AuthValid.parseJwt(token);
      setToken(token);
      setLineId(payload.sub);
      setCarNo(payload.carNo);
    } catch (error) {
      console.error('Failed to parse JWT token:', error);
      navigate('/Error404');
    }
  }, []);

  useEffect(() => {
    if (token && lineId && carNo) {
      const getInsuranceInfo = async () => {
        try {
          const queryParams = new URLSearchParams(encodeBase64Object({
            car_no: carNo,
            auth_token: token
          }));
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/prepaid_items?${queryParams.toString()}`);
          setRecords(response.data.data || []);
        } catch (error) {
          console.error('Failed to get maintenance record:', error);
          if (error.status === 401) {
            navigate('/Error401');
          } else {
            navigate('/Error500');
          }
        } finally {
          setIsLoading(false);
        }
      }
      getInsuranceInfo();
    }
  }, [token, lineId, carNo, isLoading]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="center-viewport">
      <div className="maintenance-app">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{ height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer' }} />
          </Link>
        </div>
        <div className="main-content">
          <div className="content-header">
            <div className="header-row">
              <div className="header-text">
                <div className="vehicle-number">{carNo || '查詢車牌號碼'}</div>
                <h1 className="page-title">預付商品使用紀錄</h1>
              </div>
              <div className="header-icons">
                <img src={prepaidRecordSvg} alt="預付商品icon" />
              </div>
            </div>
            <p className="description">僅提供近2年使用紀錄。</p>
            <div style={{ display: 'flex', gap: 8, margin: '16px 0' }}>
              {tabs.map(tab => (
                <button
                  key={tab.key}
                  className={activeTab === tab.key ? 'filter-tab active' : 'filter-tab'}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {filtered.length > 0 ? (
              filtered.map(r => (
                <div key={r.id} className="card-container">
                  <div className="flex-between text-sm text-muted">
                    <span>{r.store}</span>
                    <span>{r.date}</span>
                  </div>
                  <div className="flex-between items-center" style={{ marginBottom: 2 }}>
                    <span className="text-base text-dark font-normal" style={{ width: 220 }}>
                      {r.title}
                      {r.subtitle && (
                        <><br /><span className="text-base text-dark font-normal">{r.subtitle}</span></>
                      )}
                    </span>
                    <span className={
                      r.value === '已到期'
                        ? 'text-base font-normal text-red'
                        : r.value.includes('$')
                          ? 'text-base font-normal text-red'
                          : 'text-base font-normal text-red'
                    }>{r.value}</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="card-container">
                <div className="no-data-block">
                  <img src={noDataSvg} alt="no data" className="no-data-img" />
                  <div className="text-muted-base font-medium">目前尚無資料</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrepaidRecord;